import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiCheck } from "react-icons/fi";

const plans = [
  {
    type: "Veg",
    days: 45,
    meals: 30,
    originalPrice: 8970,
    price: 7999,
    perDay: 177,
    benefits: [
      "Healthy balanced veg meals",
      "Delivered everyday fresh",
      "Change or reschedule anytime",
      "Save up to 50% on subscription",
    ],
  },
  {
    type: "Non-Veg",
    days: 45,
    meals: 30,
    originalPrice: 10470,
    price: 8999,
    perDay: 199,
    benefits: [
      "Healthy non-veg meal box",
      "Delivered fresh daily",
      "Change or reschedule anytime",
      "Up to 50% off on subscription",
    ],
  },
  {
    type: "Veg",
    days: 80,
    meals: 60,
    originalPrice: 17940,
    price: 14999,
    perDay: 187,
    benefits: [
      "Healthy veg plan for 2 months",
      "Delivered fresh everyday",
      "Change or reschedule anytime",
      "Up to 50% savings",
    ],
  },
  {
    type: "Non-Veg",
    days: 80,
    meals: 60,
    originalPrice: 20940,
    price: 16999,
    perDay: 212,
    benefits: [
      "Healthy non-veg plan for 2 months",
      "Delivered fresh everyday",
      "Change or reschedule anytime",
      "Up to 50% savings",
    ],
  },
];

const formatPrice = (amount) => `₹${amount.toLocaleString("en-IN")}`;

// Shape expected by the /subcriptiondestails page
const toPlanState = (plan) => ({
  duration: `${plan.days} DAYS`,
  originalPrice: formatPrice(plan.originalPrice),
  discountedPrice: formatPrice(plan.price),
  perMonth: `${plan.perDay}/day*`,
  benefits: [
    `${plan.type} Meal ${plan.meals} Meals`,
    `Save ${formatPrice(plan.originalPrice - plan.price)} instantly`,
    `Validity ${plan.days} days`,
    ...plan.benefits,
  ].map((text) => ({ text })),
});

const Subscription_Plans = () => {
  return (
    // Mobile: swipeable row of cards. sm and up: regular grid.
    <ul className="-mx-4 mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-4 sm:mx-auto sm:grid sm:max-w-7xl sm:grid-cols-2 sm:gap-6 sm:overflow-visible sm:px-0 sm:pb-0 md:mt-12 xl:grid-cols-4">
      {plans.map((plan, index) => {
        const isVeg = plan.type === "Veg";

        return (
          <li
            key={index}
            className="flex w-[85%] shrink-0 snap-center flex-col overflow-hidden rounded-3xl border border-[#1f5c33]/10 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-xl sm:w-auto"
          >
            <div className="bg-gradient-to-br from-[#1f5c33] to-green-700 px-6 pb-6 pt-5 text-white">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold uppercase tracking-wide">
                <span
                  aria-hidden="true"
                  className={`h-2 w-2 rounded-full ${isVeg ? "bg-green-300" : "bg-red-400"}`}
                />
                {plan.type}
              </span>
              <h3 className="story-hero-head mt-4 text-4xl font-bold uppercase leading-none">
                {plan.days} Days
              </h3>
              <p className="mt-1 text-sm text-white/80">
                {plan.meals} meals · valid {plan.days} days
              </p>
            </div>

            <div className="flex flex-1 flex-col px-6 pb-6 pt-5">
              <div className="flex flex-wrap items-baseline gap-x-2">
                <span className="text-3xl font-bold text-gray-900">
                  {formatPrice(plan.price)}
                </span>
                <span className="text-sm text-gray-400 line-through">
                  {formatPrice(plan.originalPrice)}
                </span>
              </div>
              <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
                <span className="text-gray-600">₹{plan.perDay}/day*</span>
                <span className="rounded-full bg-[#eef5ef] px-2.5 py-1 font-semibold text-[#1f5c33]">
                  Save {formatPrice(plan.originalPrice - plan.price)}
                </span>
              </div>

              <ul className="mb-6 mt-5 space-y-2.5 border-t border-gray-100 pt-5 text-sm text-gray-700">
                {plan.benefits.map((benefit) => (
                  <li key={benefit} className="flex items-start gap-2.5">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#eef5ef] text-[#1f5c33]">
                      <FiCheck size={12} strokeWidth={3} aria-hidden="true" />
                    </span>
                    {benefit}
                  </li>
                ))}
              </ul>

              <Link
                to="/subcriptiondestails"
                state={{ plan: toPlanState(plan) }}
                aria-label={`Subscribe to the ${plan.days} day ${plan.type} plan`}
                className="mt-auto inline-flex h-12 w-full items-center justify-center gap-2 rounded-full bg-green-800 px-6 text-sm font-semibold text-white shadow-md transition hover:bg-green-700"
              >
                Subscribe Now
                <FiArrowRight aria-hidden="true" />
              </Link>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default Subscription_Plans;
